import React from 'react';
import { Building2, Plug } from 'lucide-react';
import { Accordion } from '@/components/ui/accordion';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { PermissionCard, SectionAccordionItem } from '../cards';
import { BulkActionsDropdown } from '../BulkActionsDropdown';

export interface DataIntegrationTabProps {
  viewIntegrations: boolean;
  onViewIntegrationsChange: (value: boolean) => void;
  manageIntegrations: boolean;
  onManageIntegrationsChange: (value: boolean) => void;
  viewCompanies: boolean;
  onViewCompaniesChange: (value: boolean) => void;
  manageCompanies: boolean;
  onManageCompaniesChange: (value: boolean) => void;
  onSelectAll: () => void;
  onDeselectAll: () => void;
}

export const DataIntegrationTab: React.FC<DataIntegrationTabProps> = ({
  viewIntegrations,
  onViewIntegrationsChange,
  manageIntegrations,
  onManageIntegrationsChange,
  viewCompanies,
  onViewCompaniesChange,
  manageCompanies,
  onManageCompaniesChange,
  onSelectAll,
  onDeselectAll,
}) => (
  <>
    <BulkActionsDropdown onSelectAll={onSelectAll} onDeselectAll={onDeselectAll} />
    <Accordion type="multiple" defaultValue={['integrations', 'company-management']} className="space-y-3">

      <SectionAccordionItem value="integrations" icon={<Plug className="h-5 w-5" />} title="Integrations" description="Manage access to system integrations and data synchronisation">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
          <PermissionCard
            label={<Label htmlFor="view-integrations" className="cursor-pointer">View Integrations</Label>}
            description="View integration configurations and status"
            onToggle={() => onViewIntegrationsChange(!viewIntegrations)}
            control={<Checkbox id="view-integrations" checked={viewIntegrations} onCheckedChange={(c) => onViewIntegrationsChange(c as boolean)} />}
          />
          <PermissionCard
            label={<Label htmlFor="manage-integrations" className="cursor-pointer">Manage Integrations</Label>}
            description="Configure, connect, and disconnect system integrations"
            onToggle={() => onManageIntegrationsChange(!manageIntegrations)}
            control={<Checkbox id="manage-integrations" checked={manageIntegrations} onCheckedChange={(c) => onManageIntegrationsChange(c as boolean)} />}
          />
        </div>
      </SectionAccordionItem>

      <SectionAccordionItem value="company-management" icon={<Building2 className="h-5 w-5" />} title="Company Management" description="Manage access to company information and settings">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
          <PermissionCard
            label={<Label htmlFor="view-companies" className="cursor-pointer">View Companies</Label>}
            description="View company list and basic information"
            onToggle={() => onViewCompaniesChange(!viewCompanies)}
            control={<Checkbox id="view-companies" checked={viewCompanies} onCheckedChange={(c) => onViewCompaniesChange(c as boolean)} />}
          />
          <PermissionCard
            label={<Label htmlFor="manage-companies" className="cursor-pointer">Manage Companies</Label>}
            description="Create, edit, and manage company settings"
            onToggle={() => onManageCompaniesChange(!manageCompanies)}
            control={<Checkbox id="manage-companies" checked={manageCompanies} onCheckedChange={(c) => onManageCompaniesChange(c as boolean)} />}
          />
        </div>
      </SectionAccordionItem>
    </Accordion>
  </>
);
